// Reconstructed from the supplied production build; original component names were unavailable.
import { Link, React, jsxRuntime, useLocation, useNavigate } from "../vendor/runtime.js";
import { useAuth } from "../context/AuthContext.jsx";
import { navLogo } from "../assets.js";
const Navbar = () => {
  var b, y, w;
  const [a, n] = React.useState(false),
    [i, l] = React.useState(false),
    { currentUser: c, logout: u } = useAuth(),
    m = useNavigate(),
    f = useLocation();
  (React.useEffect(() => {
    const N = () => {
      window.scrollY > 20 ? l(true) : l(false);
    };
    return (
      window.addEventListener("scroll", N),
      () => {
        window.removeEventListener("scroll", N);
      }
    );
  }, []),
    React.useEffect(() => {
      n(false);
    }, [f.pathname]));
  const x = (N) => {
      let T = 0;
      for (let A = 0; A < (N == null ? undefined : N.length); A++)
        T = N.charCodeAt(A) + ((T << 5) - T);
      return `hsl(${T % 360}, 70%, 60%)`;
    },
    p = async () => {
      try {
        (await u(), m("/login"));
      } catch (N) {
        console.error("Logout error:", N);
      }
    },
    g = (N) => !!((N === "/" && f.pathname === "/") || (N !== "/" && f.pathname.startsWith(N)));
  return (
    <nav className={"fixed w-full z-50 transition-all duration-300"}>
      <div className={"w-full px-2 md:px-6 lg:px-8 2xl:px-16 bg-white backdrop-blur-md shadow-lg"}>
        <div className={"flex w-full justify-between items-center h-18 sm:h-20"}>
          <div className={"flex-shrink-0 flex items-center"}>
            <Link to={"/"} className={"flex items-center space-x-2 group"}>
              <div className={"relative"}>
                <img
                  alt={"code bro , codebruh"}
                  className={"h-20 w-20 sm:w-24 sm:h-24"}
                  src={navLogo}
                  width={100}
                  fetchPriority={"high"}
                  height={100}
                />
              </div>
            </Link>
          </div>
          <div className={"hidden md:flex items-center space-x-1 lg:space-x-2"}>
            <Link
              to={"/"}
              className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 ${g("/") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-900  hover:text-indigo-600 dark:hover:text-white hover:bg-gradient-to-r from-indigo-600 to-purple-600"}`}
            >
              {"Home"}
            </Link>
            <Link
              to={"/products"}
              className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 ${g("/products") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-900  hover:text-indigo-600 dark:hover:text-white hover:bg-gradient-to-r from-indigo-600 to-purple-600"}`}
            >
              {"Browse Projects"}
            </Link>
            {c && (
              <Link
                to={"/custom-project"}
                className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 ${g("/custom-project") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-900  hover:text-indigo-600 dark:hover:text-white hover:bg-gradient-to-r from-indigo-600 to-purple-600"}`}
              >
                {"Request Custom Project"}
              </Link>
            )}
            {c && (
              <Link
                to={"/requests"}
                className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 ${g("/requests") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-900  hover:text-indigo-600 dark:hover:text-white hover:bg-gradient-to-r from-indigo-600 to-purple-600"}`}
              >
                {"View Requests"}
              </Link>
            )}
            {c && (
              <Link
                to={"/my"}
                className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 ${g("/my") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-900  hover:text-indigo-600 dark:hover:text-white hover:bg-gradient-to-r from-indigo-600 to-purple-600"}`}
              >
                {"Purchases"}
              </Link>
            )}
          </div>
          <div className={"hidden md:flex items-center space-x-6"}>
            {c ? (
              <div className={"relative group"}>
                <button
                  className={
                    "flex items-center space-x-3 text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full pl-2 pr-4 py-1.5 transition-all duration-200 shadow-sm"
                  }
                >
                  {c.profilePicture ? (
                    <img
                      src={c.profilePicture}
                      alt={"Profile"}
                      className={
                        "h-9 w-9 rounded-full object-cover border-2 border-white dark:border-gray-800 shadow-sm transition-transform duration-300 group-hover:scale-105"
                      }
                    />
                  ) : (
                    <div
                      className={
                        "h-9 w-9 rounded-full text-white flex items-center justify-center text-sm font-semibold uppercase border-2 border-white dark:border-gray-800 shadow-sm transition-transform duration-300 group-hover:scale-105"
                      }
                      style={{
                        backgroundColor: x(c.name || ""),
                      }}
                    >
                      {((b = c.name) == null ? undefined : b.charAt(0)) || "?"}
                    </div>
                  )}
                  <span className={"text-sm font-medium"}>
                    {(y = c.name) == null ? undefined : y.split(" ")[0]}
                  </span>
                  <svg
                    className={"h-4 w-4 transition-transform duration-300 group-hover:rotate-180"}
                    fill={"currentColor"}
                    viewBox={"0 0 20 20"}
                  >
                    <path
                      fillRule={"evenodd"}
                      d={
                        "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      }
                      clipRule={"evenodd"}
                    />
                  </svg>
                </button>
                <div
                  className={
                    "absolute right-0 mt-2 w-56 rounded-xl shadow-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 overflow-hidden transition-all duration-300 transform opacity-0 scale-95 translate-y-2 pointer-events-none group-hover:opacity-100 group-hover:scale-100 group-hover:translate-y-0 group-hover:pointer-events-auto"
                  }
                >
                  <div className={"py-2"}>
                    <Link
                      to={"/profile"}
                      className={
                        "block px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-indigo-50 dark:hover:bg-gray-700 hover:text-indigo-600 dark:hover:text-blue-400 transition-colors duration-200"
                      }
                    >
                      <span className={"flex items-center"}>
                        <svg
                          className={"w-4 h-4 mr-2"}
                          fill={"none"}
                          stroke={"currentColor"}
                          viewBox={"0 0 24 24"}
                          xmlns={"http://www.w3.org/2000/svg"}
                        >
                          <path
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                            strokeWidth={"2"}
                            d={
                              "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            }
                          />
                        </svg>
                        {"Profile"}
                      </span>
                    </Link>
                    <Link
                      to={"/products"}
                      className={
                        "block px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-indigo-50 dark:hover:bg-gray-700 hover:text-indigo-600 dark:hover:text-blue-400 transition-colors duration-200"
                      }
                    >
                      <span className={"flex items-center"}>
                        <svg
                          className={"w-4 h-4 mr-2"}
                          fill={"none"}
                          stroke={"currentColor"}
                          viewBox={"0 0 24 24"}
                          xmlns={"http://www.w3.org/2000/svg"}
                        >
                          <path
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                            strokeWidth={"2"}
                            d={
                              "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                            }
                          />
                          <path
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                            strokeWidth={"2"}
                            d={"M15 12a3 3 0 11-6 0 3 3 0 016 0z"}
                          />
                        </svg>
                        {"Projects"}
                      </span>
                    </Link>
                    <hr className={"my-2 border-gray-200 dark:border-gray-700"} />
                    <button
                      onClick={p}
                      className={
                        "block w-full text-left px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-indigo-50 dark:hover:bg-gray-700 hover:text-indigo-600 dark:hover:text-blue-400 transition-colors duration-200"
                      }
                    >
                      <span className={"flex items-center"}>
                        <svg
                          className={"w-4 h-4 mr-2"}
                          fill={"none"}
                          stroke={"currentColor"}
                          viewBox={"0 0 24 24"}
                          xmlns={"http://www.w3.org/2000/svg"}
                        >
                          <path
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                            strokeWidth={"2"}
                            d={
                              "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                            }
                          />
                        </svg>
                        {"Sign out"}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <jsxRuntime.Fragment>
                <Link
                  to={"/login"}
                  className={
                    "text-gray-700 dark:text-gray-900 hover:text-indigo-600 dark:hover:text-indigo-00 px-5 py-2 text-sm font-medium rounded-full border  hover:border-indigo-700 transition-all duration-200"
                  }
                >
                  {"Sign In"}
                </Link>
                <Link
                  to={"/register"}
                  className={
                    "bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-5 py-2 text-sm font-medium rounded-full shadow-md hover:shadow-lg transition-all duration-200"
                  }
                >
                  {"Sign Up"}
                </Link>
              </jsxRuntime.Fragment>
            )}
          </div>
          <div className={"flex md:hidden"}>
            <button
              onClick={() => n(!a)}
              className={
                "inline-flex items-center justify-center p-2 rounded-full text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 transition-all duration-200"
              }
              aria-expanded={"false"}
            >
              <span className={"sr-only"}>{"Open main menu"}</span>
              {a ? (
                <svg
                  className={"block h-6 w-6"}
                  xmlns={"http://www.w3.org/2000/svg"}
                  fill={"none"}
                  viewBox={"0 0 24 24"}
                  stroke={"currentColor"}
                  aria-hidden={"true"}
                >
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={"M6 18L18 6M6 6l12 12"}
                  />
                </svg>
              ) : (
                <svg
                  className={"block h-6 w-6"}
                  xmlns={"http://www.w3.org/2000/svg"}
                  fill={"none"}
                  viewBox={"0 0 24 24"}
                  stroke={"currentColor"}
                  aria-hidden={"true"}
                >
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={"M4 6h16M4 12h16M4 18h16"}
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      <div
        className={`md:hidden transition-all duration-300 ease-in-out ${a ? "max-h-screen opacity-100 visible" : "max-h-0 opacity-0 invisible"}`}
      >
        <div
          className={
            "px-4 py-4 space-y-2 bg-white dark:bg-gray-900 shadow-xl rounded-b-xl border-t border-gray-100 dark:border-gray-800"
          }
        >
          <Link
            to={"/"}
            className={`block px-4 py-3 rounded-xl text-base font-medium transition-all duration-200 ${g("/") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800"}`}
          >
            <span className={"flex items-center"}>
              <svg
                className={"w-5 h-5 mr-2"}
                fill={"none"}
                stroke={"currentColor"}
                viewBox={"0 0 24 24"}
                xmlns={"http://www.w3.org/2000/svg"}
              >
                <path
                  strokeLinecap={"round"}
                  strokeLinejoin={"round"}
                  strokeWidth={"2"}
                  d={
                    "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  }
                />
              </svg>
              {"Home"}
            </span>
          </Link>
          <Link
            to={"/products"}
            className={`block px-4 py-3 rounded-xl text-base font-medium transition-all duration-200 ${g("/products") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800"}`}
          >
            <span className={"flex items-center"}>
              <svg
                className={"w-5 h-5 mr-2"}
                fill={"none"}
                stroke={"currentColor"}
                viewBox={"0 0 24 24"}
                xmlns={"http://www.w3.org/2000/svg"}
              >
                <path
                  strokeLinecap={"round"}
                  strokeLinejoin={"round"}
                  strokeWidth={"2"}
                  d={
                    "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                  }
                />
              </svg>
              {"Browse Projects"}
            </span>
          </Link>
          {c && (
            <Link
              to={"/custom-project"}
              className={`block px-4 py-3 rounded-xl text-base font-medium transition-all duration-200 ${g("/custom-project") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800"}`}
            >
              <span className={"flex items-center"}>
                <svg
                  className={"w-5 h-5 mr-2"}
                  fill={"none"}
                  stroke={"currentColor"}
                  viewBox={"0 0 24 24"}
                  xmlns={"http://www.w3.org/2000/svg"}
                >
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={"M9 5l7 7-7 7"}
                  />
                </svg>
                {"Request Custom Project"}
              </span>
            </Link>
          )}
          {c && (
            <Link
              to={"/myrequests"}
              className={`block px-4 py-3 rounded-xl text-base font-medium transition-all duration-200 ${g("/myrequests") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800"}`}
            >
              <span className={"flex items-center"}>
                <svg
                  className={"w-5 h-5 mr-2"}
                  fill={"none"}
                  stroke={"currentColor"}
                  viewBox={"0 0 24 24"}
                  xmlns={"http://www.w3.org/2000/svg"}
                >
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={"M9 5l7 7-7 7"}
                  />
                </svg>
                {"View Requests"}
              </span>
            </Link>
          )}
          {c && (
            <Link
              to={"/my"}
              className={`block px-4 py-3 rounded-xl text-base font-medium transition-all duration-200 ${g("/my") ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-md" : "text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800"}`}
            >
              <span className={"flex items-center"}>
                <svg
                  className={"w-5 h-5 mr-2"}
                  fill={"none"}
                  stroke={"currentColor"}
                  viewBox={"0 0 24 24"}
                  xmlns={"http://www.w3.org/2000/svg"}
                >
                  <path
                    strokeLinecap={"round"}
                    strokeLinejoin={"round"}
                    strokeWidth={"2"}
                    d={"M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"}
                  />
                </svg>
                {"Purchases"}
              </span>
            </Link>
          )}
          {c ? (
            <div className={"pt-4 pb-2 border-t border-gray-200 dark:border-gray-700"}>
              <div className={"flex items-center px-4 py-2"}>
                {c.profilePicture ? (
                  <img
                    src={c.profilePicture}
                    alt={"Profile"}
                    className={
                      "h-12 w-12 rounded-full object-cover border-2 border-white dark:border-gray-800 shadow-sm"
                    }
                  />
                ) : (
                  <div
                    className={
                      "h-12 w-12 rounded-full text-white flex items-center justify-center text-lg font-semibold uppercase border-2 border-white dark:border-gray-800 shadow-sm"
                    }
                    style={{
                      backgroundColor: x(c.name || ""),
                    }}
                  >
                    {((w = c.name) == null ? undefined : w.charAt(0)) || "?"}
                  </div>
                )}
                <div className={"ml-3"}>
                  <div className={"text-base font-medium text-gray-800 dark:text-gray-200"}>
                    {c.name}
                  </div>
                  <div className={"text-sm font-medium text-gray-500 dark:text-gray-400"}>
                    {c.email}
                  </div>
                </div>
              </div>
              <div className={"mt-3 space-y-2 px-2"}>
                <Link
                  to={"/profile"}
                  className={
                    "block px-4 py-3 rounded-xl text-base font-medium text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
                  }
                >
                  <span className={"flex items-center"}>
                    <svg
                      className={"w-5 h-5 mr-2"}
                      fill={"none"}
                      stroke={"currentColor"}
                      viewBox={"0 0 24 24"}
                      xmlns={"http://www.w3.org/2000/svg"}
                    >
                      <path
                        strokeLinecap={"round"}
                        strokeLinejoin={"round"}
                        strokeWidth={"2"}
                        d={"M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"}
                      />
                    </svg>
                    {"Profile"}
                  </span>
                </Link>
                <Link
                  to={"/products"}
                  className={
                    "block px-4 py-3 rounded-xl text-base font-medium text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
                  }
                >
                  <span className={"flex items-center"}>
                    <svg
                      className={"w-5 h-5 mr-2"}
                      fill={"none"}
                      stroke={"currentColor"}
                      viewBox={"0 0 24 24"}
                      xmlns={"http://www.w3.org/2000/svg"}
                    >
                      <path
                        strokeLinecap={"round"}
                        strokeLinejoin={"round"}
                        strokeWidth={"2"}
                        d={
                          "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                        }
                      />
                      <path
                        strokeLinecap={"round"}
                        strokeLinejoin={"round"}
                        strokeWidth={"2"}
                        d={"M15 12a3 3 0 11-6 0 3 3 0 016 0z"}
                      />
                    </svg>
                    {"Projects"}
                  </span>
                </Link>
                <button
                  onClick={p}
                  className={
                    "block w-full text-left px-4 py-3 rounded-xl text-base font-medium text-gray-700 dark:text-gray-200 hover:text-blue-400 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
                  }
                >
                  <span className={"flex items-center"}>
                    <svg
                      className={"w-5 h-5 mr-2"}
                      fill={"none"}
                      stroke={"currentColor"}
                      viewBox={"0 0 24 24"}
                      xmlns={"http://www.w3.org/2000/svg"}
                    >
                      <path
                        strokeLinecap={"round"}
                        strokeLinejoin={"round"}
                        strokeWidth={"2"}
                        d={
                          "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        }
                      />
                    </svg>
                    {"Sign out"}
                  </span>
                </button>
              </div>
            </div>
          ) : (
            <div className={"pt-4 pb-2 border-t border-gray-200 dark:border-gray-700"}>
              <div className={"space-y-3 px-2"}>
                <Link
                  to={"/login"}
                  className={
                    "flex items-center justify-center w-full px-4 py-3 rounded-xl text-base font-medium text-gray-900 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-blue-400 border border-gray-300 dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-400 transition-all duration-200"
                  }
                >
                  <svg
                    className={"w-5 h-5 mr-2"}
                    fill={"none"}
                    stroke={"currentColor"}
                    viewBox={"0 0 24 24"}
                    xmlns={"http://www.w3.org/2000/svg"}
                  >
                    <path
                      strokeLinecap={"round"}
                      strokeLinejoin={"round"}
                      strokeWidth={"2"}
                      d={
                        "M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                      }
                    />
                  </svg>
                  {"Sign In"}
                </Link>
                <Link
                  to={"/register"}
                  className={
                    "flex items-center justify-center w-full px-4 py-3 rounded-xl text-base font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-md hover:shadow-lg transition-all duration-200"
                  }
                >
                  <svg
                    className={"w-5 h-5 mr-2"}
                    fill={"none"}
                    stroke={"currentColor"}
                    viewBox={"0 0 24 24"}
                    xmlns={"http://www.w3.org/2000/svg"}
                  >
                    <path
                      strokeLinecap={"round"}
                      strokeLinejoin={"round"}
                      strokeWidth={"2"}
                      d={
                        "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                      }
                    />
                  </svg>
                  {"Sign Up"}
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export { Navbar };
